export default function Achievements() {
  return <div>Achievements Page</div>;
}
